export const fmtEUR = (n) => {
    if (n === null || n === undefined || Number.isNaN(n)) return "—";
    return new Intl.NumberFormat("en-IE", {
        style: "currency",
        currency: "EUR",
        maximumFractionDigits: 2,
    }).format(n);
};

export const fmtPct = (n) => {
    if (n === null || n === undefined || Number.isNaN(n)) return "—";
    return `${Number(n).toLocaleString("en-IE", { maximumFractionDigits: 2 })}%`;
};
